import { actionTypes } from '../actions/constants.ts';

type HeaderState = {
    isVipCuratedFolderTooltipVisible: boolean;
    initialTrackingFired: boolean;
    updateUserState?: boolean;
    deviceType?: string;
    isMobileMenuOpen?: boolean;
    isImageSearchModalOpen?: boolean;
};

type HeaderActionType =
    | {
          type: typeof actionTypes.SET_UPDATE_USER_STATE;
          updateUserState: boolean;
      }
    | { type: typeof actionTypes.INITIAL_TRACKING_FIRED }
    | {
          type: typeof actionTypes.RESET_TRACKING_FIRED;
      }
    | {
          type: typeof actionTypes.SET_DEVICE_TYPE;
          deviceType: string;
      }
    | {
          type: typeof actionTypes.TOGGLE_MOBILE_MENU;
          isMobileMenuOpen: boolean;
      }
    | { type: typeof actionTypes.SET_IMAGE_SEARCH_MODAL_OPEN }
    | { type: typeof actionTypes.SET_IMAGE_SEARCH_MODAL_CLOSED }
    | {
          type: typeof actionTypes.TOGGLE_VIP_CURATED_FOLDER_TOOLTIP_STATE;
      };

export default function headerReducer(
    state = {
        isVipCuratedFolderTooltipVisible: false,
        initialTrackingFired: false,
    },
    action: HeaderActionType
): HeaderState {
    switch (action.type) {
        case actionTypes.SET_UPDATE_USER_STATE:
            return {
                ...state,
                updateUserState: action.updateUserState,
                initialTrackingFired: false,
            };
        case actionTypes.INITIAL_TRACKING_FIRED:
            return {
                ...state,
                initialTrackingFired: true,
            };
        case actionTypes.RESET_TRACKING_FIRED:
            return {
                ...state,
                initialTrackingFired: false,
            };
        case actionTypes.SET_DEVICE_TYPE:
            return {
                ...state,
                deviceType: action.deviceType,
            };
        case actionTypes.TOGGLE_MOBILE_MENU:
            return {
                ...state,
                isMobileMenuOpen: action.isMobileMenuOpen,
            };
        case actionTypes.SET_IMAGE_SEARCH_MODAL_OPEN:
            return { ...state, isImageSearchModalOpen: true };
        case actionTypes.SET_IMAGE_SEARCH_MODAL_CLOSED:
            return { ...state, isImageSearchModalOpen: false };
        case actionTypes.TOGGLE_VIP_CURATED_FOLDER_TOOLTIP_STATE:
            return {
                ...state,
                isVipCuratedFolderTooltipVisible: !state.isVipCuratedFolderTooltipVisible,
            };
        default:
            return state;
    }
}
